import { Component, OnInit, Input, Output, EventEmitter, ChangeDetectorRef } from "@angular/core";
import { UntypedFormControl, UntypedFormGroup } from "@angular/forms";

import { ShareDataService } from "../../services/share-data.service";
import { ADPResourceService as ResourceService } from "digital-core";
import { Resource, ListItem} from 'digital-core';
import { CustomFormControl, CustomIdBase } from "digital-core";
import { QuestionInfo } from "common/models/common/question-info";
import { BoxQuestionComponentStyle } from "common/models/common/enums";
import { AnswerInfo } from "common/models/common/answer-info";

@Component({
  selector: "gsp-box-question",
  templateUrl: "./box-question.component.html",
  styleUrls: ["./box-question.component.css"]
})
export class BoxQuestionComponent extends CustomIdBase implements OnInit {
  @Input()
  index: number;

  @Input()
  total: number;

  @Input()
  totalQuestions: number;

  @Input()
  question: QuestionInfo;

  @Input()
  formStyle: BoxQuestionComponentStyle = BoxQuestionComponentStyle.RadioButton;

  // ================ Input One ===========================
  @Input()
  controlOne: CustomFormControl;

  @Input() listItemsOne: ListItem[];

  @Input()
  resourceDataOne: Resource;

  @Input()
  classControlOne = "fullWidth";

  // =================================================

  // ================= Input Two =========================
  @Input()
  controlTwo: CustomFormControl;

  @Input() listItemsTwo: ListItem[];

  @Input()
  resourceDataTwo: Resource;

  @Input()
  classControlTwo = "fullWidth";

  // =================================================

  @Input()
  demandNeedSection: HTMLElement;

  @Input()
  enabled: boolean;

  @Input()
  showNumber = true;

  @Output()
  nextStep = new EventEmitter();

  @Output()
  selectedStep = new EventEmitter<number>();

  @Input()
  expanded: boolean;

  @Input()
  hidden = false;

  @Input()
  filter: string;

  @Output()
  selectionChange = new EventEmitter<QuestionInfo>();

  @Output()
  formControlChange = new EventEmitter<UntypedFormGroup>();

  public questionsFormControl: UntypedFormControl;

  public containerFormControl;

  constructor(public resourcesService: ResourceService, private shareDataService: ShareDataService, private cd: ChangeDetectorRef) {
    super();
    this.containerFormControl = new UntypedFormGroup({
      inputControlOne:
        this.controlOne === undefined ? new CustomFormControl() : this.controlOne,
      inputControlTwo:
        this.controlTwo === undefined ? new CustomFormControl() : this.controlTwo // ,
    });
  }

  ngOnInit() {
    

    // if we don't have a question then use the value of object resourceDataOne
    if (this.question === undefined) {
      this.question = new QuestionInfo();
      this.question.QuestionText = this.resourceDataOne.Value; 
    }
    


    if (this.question && !this.question.Answer) {
      this.question.Answer = new AnswerInfo();

      this.questionsFormControl = new UntypedFormControl(
        this.question.Answer.AnswerText
      );
    }
    // get and apply filter
    if (this.resourceDataOne.Filter !== undefined 
      && this.filter !== undefined
      && this.resourceDataOne.Filter !== null 
      && this.filter !== null  ) {

      if (this.resourceDataOne.Filter.indexOf(this.filter) > -1) {
        this.hidden = false;
      } else {
        this.hidden = true;
      }
        
    }

  }

  getResource(resource: any) {
    return this.resourcesService.getViewResource(resource);
  }

  getFormGroup() {
    return this.containerFormControl;
  }

  getQuestionInfo() {
    return this.question;
  }

  openPanel() {
    this.expanded = true;
    this.selectedStep.emit(this.index);
  }

  selectionChanged(_event: any) {
    let scope = this;
    setTimeout(() => {
      if (scope.questionsFormControl && scope.questionsFormControl.value) {
        scope.question.Answer.AnswerText = scope.questionsFormControl.value;
        scope.question.Completed = true;
      } else {
        scope.question.Completed = false;
      }
      scope.nextStep.emit();
      scope.selectionChange.emit(scope.question);
    });
  }

  ngFormModelChangeEvent(_event: any) {
    this.formControlChange.emit(this.containerFormControl);
  }
  isValid(): boolean {
    return this.containerFormControl.valid;
  }

  getQuestionId() {
    return this.question.Title;
  }
}
